import { Component, OnInit, Input } from '@angular/core';

import * as XLSX from 'xlsx';

import { environment } from '../../../environments/environment';
import { ErrorHandler, HandleError } from '../../services/error-handler.service';

import { UserService } from '../../services/user.service';
import { UtilityService, AOA } from '../../services/utility.service';

@Component({
  selector: 'app-excel-export',
  templateUrl: './excel-export.component.html',
  styleUrls: ['./excel-export.component.scss']
})
export class ExcelExportComponent implements OnInit {
  @Input() disabled = false;
  @Input() fileName: string;
  @Input() appendDateTimeToFileName: false;
  @Input() exportType = 'xlsx';

  @Input() dataToExport: any[][] = [];
  @Input() columnsToExport: string[][] = [];

  private _sheetNames: string[] = [];
  private _sheetNamesDelimitedString: string;
  @Input()
  set sheetNames(sheetNames: string[]) {
    this._sheetNames = sheetNames;
  }
  get sheetNames(): string[] {
    return this._sheetNames;
  }
  @Input() sheetNamesDelimiter = ',';
  @Input()
  set sheetNamesDelimitedString(sheetNamesDelimitedString: string) {
    this._sheetNames = sheetNamesDelimitedString.split(this.sheetNamesDelimiter);
    this._sheetNamesDelimitedString = sheetNamesDelimitedString;
  }
  get sheetNamesDelimitedString(): string {
    return this._sheetNamesDelimitedString;
  }

  private _columnLabels: string[][] = [];
  private _columnLabelsDelimitedString: string;
  @Input()
  set columnLabels(columnLabels: string[][]) {
    this._columnLabels = columnLabels;
  }
  get columnLabels(): string[][] {
    return this._columnLabels;
  }
  @Input() columnLabelsDelimiter = ',';
  @Input() columnLabelsSheetsDelimiter = '|';
  @Input()
  set columnLabelsDelimitedString(columnLabelsDelimitedString: string) {
    this._columnLabels = [];
    let columnLabelSheets: string[];
    columnLabelSheets = columnLabelsDelimitedString.split(this.columnLabelsSheetsDelimiter);
    for (const sheet of columnLabelSheets) {
      const sheetData = sheet.split(this.columnLabelsDelimiter);
      this._columnLabels.push(sheetData.slice());
    }
    this._columnLabelsDelimitedString = columnLabelsDelimitedString;
  }
  get columnLabelsDelimitedString(): string {
    return this._columnLabelsDelimitedString;
  }

  private _handleError: HandleError;
  private _logging = environment.logging;

  constructor(private _errorHandler: ErrorHandler, private _userService: UserService, private _utilityService: UtilityService) {
    this._handleError = _errorHandler.createHandleError('ExcelExportComponent');
  }

  ngOnInit() {}

  exportToExcel(): void {
    if (this._userService.isLoggedIn()) {
      try {
        const exportDataList: AOA[] = [];
        let i = -1;
        for (const data of this.dataToExport) {
          i += 1;
          let dataAOA: AOA = [];
          dataAOA = this._utilityService.convertJSONObjectArrayToAOA(data, this.columnsToExport[i].slice());
          dataAOA.unshift(this._columnLabels[i].slice());
          exportDataList.push(dataAOA.slice());
        }

        const now = new Date();
        let exportFileName =
          this.fileName +
          (this.appendDateTimeToFileName
            ? '_' +
              now.getFullYear() +
              '_' +
              now.getMonth() +
              '_' +
              now.getDate() +
              '_' +
              now.getHours() +
              '_' +
              now.getMinutes() +
              '_' +
              now.getSeconds()
            : '') +
          '.' +
          this.exportType;
        exportFileName = exportFileName.replace(/ /g, '_');

        const wb: XLSX.WorkBook = XLSX.utils.book_new();
        i = -1;
        for (const exportData of exportDataList) {
          i += 1;
          const ws: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(exportData);
          XLSX.utils.book_append_sheet(wb, XLSX.utils.aoa_to_sheet(exportData), this._sheetNames[i]);
        }

        const opts = {
          bookType: this.exportType
        };

        XLSX.writeFile(wb, exportFileName, <any>opts);
      } catch (e) {
        this._handleError('exportToExcel', e, {
          disabled: this.disabled,
          dataToExport: this.dataToExport,
          columnsToExport: this.columnsToExport,
          columnLabels: this.columnLabels,
          sheetNames: this._sheetNames
        });
      }
    }
  }
}
